/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import { createSlice } from '@reduxjs/toolkit';

import { getServiceProviders } from './service-providers.middleware';
import { logout } from '../auth/auth-middleware';
import { ServiceProvider } from 'api';

type ServiceProvidersState = {
    providers: ServiceProvider[];
    error: string | null;
    isLoading: boolean;
};

const initialState: ServiceProvidersState = {
    providers: [],
    error: null,
    isLoading: false,
};

export const serviceProvidersSlice = createSlice({
    name: 'app/service-providers',
    initialState,
    reducers: {
        reset: (state) => {
            state.providers = [];
            state.error = null;
            state.isLoading = false;
        },
    },
    extraReducers: (builder) => {
        builder
            // GET
            .addCase(getServiceProviders.fulfilled, (state, action) => {
                const results = action.payload
                    .filter((val): val is PromiseFulfilledResult<any> => val.status === 'fulfilled')
                    .map((val) => val.value);
                const providersResponse = results.map((item) => item.payload.data);
                state.providers = providersResponse;
            })
            .addCase(getServiceProviders.pending, (state) => {
                state.isLoading = true;
                state.error = null;
                state.providers = [];
            })
            .addCase(getServiceProviders.rejected, (state, action) => {
                const errorMsg = (action.payload as { msg: string }).msg
                    ? (action.payload as { msg: string }).msg
                    : 'Something went wrong';
                state.isLoading = false;
                state.error = errorMsg;
                state.providers = [];
            })
            .addCase(logout.fulfilled, (state) => {
                state.providers = [];
                state.error = null;
                state.isLoading = false;
            });
    },
});

export const { reset } = serviceProvidersSlice.actions;
export default serviceProvidersSlice.reducer;
